import { render, staticRenderFns } from "./NewVenueOverview.vue?vue&type=template&id=24013f92&scoped=true&"
import script from "./NewVenueOverview.vue?vue&type=script&lang=js&"
export * from "./NewVenueOverview.vue?vue&type=script&lang=js&"
import style0 from "./NewVenueOverview.vue?vue&type=style&index=0&id=24013f92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24013f92",
  null
  
)

export default component.exports